import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-pginicio',
  templateUrl: './pginicio.component.html',
  styleUrls: ['./pginicio.component.scss']
})
export class PginicioComponent implements OnInit {

  constructor(public router: Router) { }
  modulos;
  id_cliente;
  ngOnInit() {
    try {
      this.id_cliente = localStorage.getItem("id_cliente")
      this.modulos=localStorage.getItem("modulos").split(",")  
    } catch (error) {
      this.modulos=[];
    }
    this.despliega_menu();
  }
  bnd_menu_desa=false;
  bnd_menu_chart=false;
  bnd_menu_crm=false;
  bnd_menu_adm=false;
  bnd_dc3=false;
  despl_desa=false;
  despl_chart=false;
  despl_crm=false;
  despl_adm=false;
  bnd_menu_capacitacion=false;
  
  bnd_role=false;
  bnd_estructura=false;
  bnd_persona=false;
  bnd_competencias=false;

  bnd_org=false;
  bnd_raci=false;
  bnd_ddf=false;
  bnd_servicios=false;
  bnd_tkt=false;
  bnd_hk=false;
  bnd_desp=false;

  bnd_cal=false;
  bnd_pro=false;
  bnd_celen=false;
  bnd_task=false;  
  
  bnd_usu=false;
  bnd_edtcli=false;
  
  bnd_capacit=false;
  despl_capa=false;
  despl_rh=false;
  despl_chart2=false;
 
  despliega_menu(){
    this.bnd_menu_desa=false;
    this.bnd_menu_chart=false;
    this.bnd_menu_crm=false;
    this.bnd_menu_adm=false;
    this.bnd_menu_capacitacion=false;
    
    this.bnd_role=false;
      this.bnd_estructura=false;
      this.bnd_persona=false;
      this.bnd_competencias=false;    
      this.bnd_org=false;
      this.bnd_raci=false;
      this.bnd_ddf=false;
      this.bnd_servicios=false;
      this.bnd_tkt=false;
      this.bnd_hk=false;
      this.bnd_desp=false;    
      this.bnd_cal=false;
      this.bnd_pro=false;
      this.bnd_celen=false;
      this.bnd_task=false;      
      this.bnd_usu=false;
      this.bnd_edtcli=false;      
      this.bnd_capacit=false;
    if(localStorage.getItem("garoce")=="1"){
      this.bnd_menu_desa=true;
      this.bnd_menu_chart=true;
      this.bnd_menu_crm=true;
      this.bnd_menu_adm=true;
      this.bnd_menu_capacitacion=true;
      this.bnd_role=true;
      this.bnd_estructura=true;
      this.bnd_persona=true;
      this.bnd_competencias=true;    
      this.bnd_org=true;
      this.bnd_raci=true;
      this.bnd_ddf=true;
      this.bnd_servicios=true;
      this.bnd_tkt=true;
      this.bnd_hk=true;
      this.bnd_desp=true;    
      this.bnd_cal=true;
      this.bnd_pro=true;
      this.bnd_celen=true;
      this.bnd_task=true;      
      this.bnd_usu=true;
      this.bnd_edtcli=true;      
      this.bnd_capacit=true;
      this.bnd_dc3=true;
          
    }else{
    if(this.modulos.length>0){
      for(var i=0;i<this.modulos.length;i++){        
        switch (Number(this.modulos[i])) {
          case 1:this.bnd_raci=true;this.bnd_menu_chart=true;break;
          case 22:this.bnd_ddf=true;this.bnd_menu_chart=true;break;
          case 2:this.bnd_servicios=true;this.bnd_menu_chart=true;break;
          case 3:this.bnd_tkt=true;this.bnd_menu_chart=true;break;
          case 4:this.bnd_hk=true;this.bnd_menu_chart=true;break;
          case 5:this.bnd_desp=true;this.bnd_menu_chart=true;break;
          case 12:this.bnd_org=true;this.bnd_menu_chart=true;break;

          case 6:this.bnd_pro=true;this.bnd_menu_crm=true;break;
          case 7:this.bnd_cal=true;this.bnd_menu_crm=true;break;
          case 8:this.bnd_task=true;this.bnd_menu_crm=true;break;
          case 9:this.bnd_celen=true;this.bnd_menu_crm=true;break;
          
          case 10:this.bnd_capacit=true;this.bnd_menu_capacitacion=true;break;
          case 18:this.bnd_capacit=true;this.bnd_menu_capacitacion=true;break;
         
          case 17:this.bnd_competencias=true;this.bnd_menu_desa=true;break;
          case 13:this.bnd_estructura=true;this.bnd_menu_desa=true;break;
          case 14:this.bnd_persona=true;this.bnd_menu_desa=true;break;
          case 15:this.bnd_role=true;this.bnd_menu_desa=true;break;   
          case 19:
          case 20:
          case 21:
            this.bnd_dc3=true;
          break;                 
          case 11:this.bnd_usu=true;this.bnd_menu_adm=true;break;
          case 16:this.bnd_edtcli=true;this.bnd_menu_adm=true;break;    
        }
      }
      }
    }
   
  } 

  bndrh=true; 
  bnddesa=true;
  bndcrm=true;
  bndcharts=true;
  bndcapa=true;
  bndadm=true;
  bndcharts2=true;
  bndHerr=true;
  clean(){
    this.bndcharts2=true;
    this.bndrh=true 
    this.bnddesa=true;
    this.bndcrm=true;
    this.bndcharts=true;
    this.bndcapa=true;
    this.bndadm=true;
    this.bndHerr=true;
  }
  c_herr(){
    this.clean()
    if(this.bndHerr==true){
      this.bndHerr=false;
    }else{
      this.bndHerr=true;
    }
  }
  regresa(){
    this.router.navigate(["/lista_cliente"]);
  }
  cerrarsesion(){
    this.router.navigate(["/"]);
  }
  c_adm(){
    this.clean()
    if(this.bndadm==true){
      this.bndadm=false;
    }else{
      this.bndadm=true;
    }    
  }
  c_capa(){
    this.clean()
    if(this.bndcapa==true){
      this.bndcapa=false;
    }else{
      this.bndcapa=true;
    }
    
  }
  c_rh(){
    this.clean()
    if(this.bndrh==true){
      this.bndrh=false;
    }else{
      this.bndrh=true;
    }
    
  }
  c_racsi(){
    this.clean()
    if(this.bndcharts==true){
      this.bndcharts=false;
    }else{
      this.bndcharts=true;
    }
  }
  c_racsi2(){
    this.clean()
    if(this.bndcharts2==true){
      this.bndcharts2=false;
    }else{
      this.bndcharts2=true;
    }
  }
  _go(a){
    //localStorage.setItem("menu_","1");    
    this.router.navigate([a]);
  }
  c_desa(){
    this.clean()
    if(this.bnddesa==true){
      this.bnddesa=false;
    }else{
      this.bnddesa=true;
    }
  }
  c_crm(){
    this.clean()
    if(this.bndcrm==true){
      this.bndcrm=false;
    }else{
      this.bndcrm=true;
    }
  }
}
